import { style } from '@vanilla-extract/css'

const screenContainer = style({
  backgroundColor: '#F2F1EF',
  fontFamily: 'Noto Sans JP Variable, sans-serif',
  color: '#252525',
  '@media': {
    '(min-width: 960px)': {
      height: '100vh',
      overflowY: 'hidden',
    },
  },
})

const pageContainer = style({
  maxWidth: '540px',
  backgroundColor: '#F2F1EF',
  '@media': {
    '(min-width: 960px)': {
      width: '440px',
      height: '100%',
      overflowY: 'scroll',
      margin: '80px 12px 0',
      borderRadius: '40px 40px 0 0',
    },
  },
})

const copyRight = style({
  margin: '0 0 120px',
  transform: 'rotate(90deg)',
  transformOrigin: 'bottom left',
  fontSize: '13px',
  color: '#858585',
  '@media': {
    '(max-width: 960px)': {
      display: 'none',
    },
  },
})

const nutrientPopup = style({
  position: 'relative',
  borderRadius: '8px',
  backgroundColor: 'white',
  color: '#e63e27',
  fontSize: '13px',
  fontWeight: '700',
  padding: '6px 12px',
  textAlign: 'center',
  boxShadow: '0 2px 12px 1px rgba(0, 0, 0, 0.08)',
  backdropFilter: 'blur(2px)',
  ':after': {
    content: '""',
    display: 'block',
    position: 'absolute',
    bottom: '-8px',
    margin: '0 auto',
    borderLeft: '7px solid transparent',
    borderRight: '7px solid transparent',
    borderTop: '10px solid white',
  },
})

const subscribeButton = style({
  maxWidth: '540px',
  width: '100%',
  padding: '16px 24px',
  display: 'flex',
  flexFlow: 'column nowrap',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px',
})

const bottomFixed = style({
  position: 'fixed',
  bottom: '-200px',
  left: '50%',
  transform: 'translateX(-50%)',
  transition: 'bottom 0.3s ease-in-out',
  zIndex: 10,
})

const bottomFixedVisible = style({
  bottom: '0',
})

const mobileOnly = style({
  '@media': {
    '(min-width: 960px)': {
      display: 'none',
    },
  },
})

export const styles = {
  screenContainer,
  pageContainer,
  copyRight,
  nutrientPopup,
  subscribeButton,
  bottomFixed,
  bottomFixedVisible,
  mobileOnly,
}
